import React from "react";
import { Link } from "react-router-dom";
import NavBar from './NavBar';
import YouTubeButton from './YouTubeButton';
import Footer from './Footer';
import "./Artisti.css";

export default function Studio() {
  return (
    <div className="publicsite-bg page-studio">
      <Link to="/login" className="dash-badge">Dashboard</Link>
      <div className="logo-wrapper">
        <div className="logo-stack">
          <img src="/disco.png" alt="Disco" className="disco-img" />
          <img src="/logo.png" alt="Logo Arte Registrazioni" className="logo-img" />
        </div>
      </div>
    <NavBar />
      <div className="container studio-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <button type="button" className="studio-btn" aria-label="Arte Studio a schermo intero">
          <img src="/artestudio.jpg" alt="Arte Studio a schermo intero" />
        </button>
      </div>
      <div className="youtube-under-menu">
        <YouTubeButton small layout="row" />
      </div>
      <Footer />
    </div>
  );
}
